import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { path: '/dashboard', label: 'Home', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H5a1 1 0 01-1-1V9.5z"/>
      <path d="M9 21V12h6v9"/>
    </svg>
  )},
  { path: '/send', label: 'Send', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z"/>
    </svg>
  )},
  { path: '/buy', label: 'Add Funds', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <circle cx="12" cy="12" r="10"/>
      <path d="M12 8v8M8 12h8"/>
    </svg>
  )},
  { path: '/request', label: 'Request', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <path d="M2 10h20"/>
    </svg>
  )},
  { path: '/move', label: 'Move', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4"/>
    </svg>
  )},
  { path: '/transactions', label: 'Transactions', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  )},
  { path: '/recurring', label: 'Payment Links', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <polyline points="17 1 21 5 17 9"/>
      <path d="M3 11V9a4 4 0 014-4h14"/>
      <polyline points="7 23 3 19 7 15"/>
      <path d="M21 13v2a4 4 0 01-4 4H3"/>
    </svg>
  )},
  { path: '/cashout', label: 'Cash Out', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <rect x="1" y="4" width="22" height="16" rx="2"/>
      <line x1="1" y1="10" x2="23" y2="10"/>
    </svg>
  )},
  { path: '/banks', label: 'Bank Connections', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  )},
  { path: '/tax', label: 'Tax Summary', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  )},
  { path: '/settings', label: 'Settings', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  )},
  { path: '/integrations', label: 'Integrations', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={active?'#007AFF':'#6E6E73'} strokeWidth="1.8">
      <rect x="2" y="3" width="6" height="6" rx="1"/>
      <rect x="16" y="3" width="6" height="6" rx="1"/>
      <rect x="2" y="15" width="6" height="6" rx="1"/>
      <rect x="16" y="15" width="6" height="6" rx="1"/>
      <path d="M8 6h8M5 9v6M19 9v6M8 18h8"/>
    </svg>
  )},
];

export default function DesktopSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <aside style={s.sidebar}>
      <div style={s.logoWrap}>
        <img src="/tbold-logo-cal-04.svg" alt="Thunderbolt" style={s.logo}/>
      </div>

      <div style={s.userWrap}>
        <div style={s.avatar}>
          {user?.name?.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)}
        </div>
        <div style={s.userInfo}>
          <div style={s.userName}>{user?.name?.split(' ')[0]}</div>
          <div style={s.userEmail}>{user?.email || user?.phone}</div>
        </div>
      </div>

      <nav style={s.nav}>
        {NAV_ITEMS.map(item => {
          const active = location.pathname === item.path;
          return (
            <button
              key={item.path}
              style={{...s.navBtn, ...(active ? s.navBtnActive : {})}}
              onClick={() => navigate(item.path)}
            >
              <item.icon active={active}/>
              <span style={{...s.navLabel, color: active ? '#007AFF' : '#1D1D1F'}}>
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>

      <div style={s.footer}>
        <button style={s.logoutBtn} onClick={logout}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF3B30" strokeWidth="1.8">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
          </svg>
          Log out
        </button>
        <a href="/terms" style={s.termsLink}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          Terms of Service
        </a>
      </div>
    </aside>
  );
}

const s = {
  sidebar:     { width:240, flexShrink:0, height:'100vh', position:'fixed', left:0, top:0, background:'#fff', borderRight:'1px solid #F0F0F0', display:'flex', flexDirection:'column', zIndex:100 },
  logoWrap:    { padding:'24px 20px 16px' },
  logo:        { height:36, objectFit:'contain' },
  userWrap:    { display:'flex', alignItems:'center', gap:10, padding:'12px 16px', margin:'0 8px 8px', background:'#F5F5F7', borderRadius:12 },
  avatar:      { width:32, height:32, borderRadius:'50%', background:'#007AFF', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:600, flexShrink:0 },
  userInfo:    { flex:1, minWidth:0 },
  userName:    { fontSize:13, fontWeight:600, color:'#1D1D1F' },
  userEmail:   { fontSize:11, color:'#6E6E73', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' },
  nav:         { flex:1, overflowY:'auto', padding:'4px 8px' },
  navBtn:      { display:'flex', alignItems:'center', gap:12, width:'100%', padding:'10px 12px', background:'none', border:'none', borderRadius:10, cursor:'pointer', marginBottom:2 },
  navBtnActive:{ background:'#EBF4FF' },
  navLabel:    { fontSize:14, fontWeight:500 },
  footer:      { padding:'12px 16px 24px', borderTop:'1px solid #F5F5F7' },
  logoutBtn:   { display:'flex', alignItems:'center', gap:8, width:'100%', padding:'10px 14px', background:'#FFF0EF', border:'none', borderRadius:10, fontSize:13, fontWeight:500, color:'#FF3B30', cursor:'pointer', marginBottom:8 },
  termsLink:   { display:'flex', alignItems:'center', justifyContent:'center', gap:6, fontSize:11, color:'#AEAEB2', textDecoration:'none', padding:'4px 0' },
};
